import { IGetChecklistServicoAmbienteByIdUseCase } from "../../../presentation/useCases/read/get_checklist_servico_ambiente_by_id_use_case";
import { ChecklistServicoAmbienteModel } from "../../models/checklist_servico_ambiente";
import { IObrasRepository } from "../../repositories/obras_repository";
/**
 * GetChecklistServicoAmbienteByIdUseCase
 */

export class GetChecklistServicoAmbienteByIdUseCase implements IGetChecklistServicoAmbienteByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(idChecklistServicoAmbiente: number): Promise<ChecklistServicoAmbienteModel> {
    return await this.repository.getChecklistServicoAmbienteById(idChecklistServicoAmbiente);
  }
}
